module.exports = __webpack_public_path__ + "static/img/snip3down.1807a93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/discord/snip3down.png
// module id = xFZo
// module chunks = 35